<template>
  <Section
    decoration="/images/sunburst.svg"
    :index="4"
    :title="t('sections.skills')"
    id="skills"
  >
    <ul>
      <Litem
        v-for="skill in skillset"
        :key="skill.title"
      >
        <template v-slot:presentation>
          <p class="skills__title">
            {{ skill.title }}
          </p>
        </template>
        <template v-slot:content>
          <ul class="skills__set">
            <li
              v-for="item in skill.set"
              :key="item"
              class="skills__item"
            >
              {{ item }}
            </li>
          </ul>
        </template>
      </Litem>
    </ul>
  </Section>
</template>
  
<script lang="ts" setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import Litem from '@/ui/Litem.vue';
import Section from '@/ui/Section.vue';

const { t, tm } = useI18n();

const skillset = computed(() => [
  {
    title: t('skills.programming'),
    set: [
      'JavaScript',
      'TypeScript',
      'Python',
      'C++',
    ],
  },
  {
    title: t('skills.web.title'),
    set: [
      'HTML',
      'CSS/SCSS',
      ...(tm('skills.web.set') as string[]),
    ],
  },
  {
    title: t('skills.frameworks'),
    set: [
      'Vue',
      'Nuxt',
      'Astro',
      'Angular',
    ],
  },
  {
    title: t('skills.tools'),
    set: [
      'Vite',
      'Git',
      'Docker',
      'Webpack',
    ],
  },
  {
    title: t('skills.testing'),
    set: [
      'Vitest',
      'Jest',
      'Cypress',
      'Playwright',
      'Nightwatch',
    ],
  },
  {
    title: t('skills.databases'),
    set: [
      'SQL',
    ],
  },
  {
    title: t('skills.languages.title'),
    set: tm('skills.languages.set'),
  },
]);
</script>

<style lang="scss" scoped>
@use '@/styles/screens';

.skills__title {
  color: var(--color-text-strong);
  font-family: var(--font-family-display);
  font-size: 18px;
  font-weight: 400;
  text-align: left;
  
  @include screens.tablet {
    text-align: right;
  }

  @include screens.desktop {
    margin-right: 32px;
  }
}

.skills__set {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.skills__item {
  background-color: var(--color-background-strong);
  border: 1px solid var(--color-border);
  border-radius: 999px;
  cursor: default;
  font-family: var(--font-family-mono);
  font-size: 16px;
  padding: 8px 16px;
  transition: border-color 0.3s ease-in-out, color 0.3s ease-in-out;

  &:hover {
    border-color: var(--color-highlight);
    color: var(--color-highlight);
  }
}
</style>
